import { BasketMarketOfferEntity } from '@genial/services';
import { Utils } from '@genial/utils';

import { messageError } from '../constants';

import { baseNormalization, normalizeCustomerBasketOffersData } from '.';

export const normalizeCustomerBasketOffersCoe = (data?: BasketMarketOfferEntity[]) => {
  if (!data) {
    return [];
  }

  const coeData = data.find((item) => item.marketType === 'COE');

  if (!coeData) {
    return [];
  }

  const coeNormalizedData = normalizeCustomerBasketOffersData(coeData?.basketOffers);

  return coeNormalizedData.map((item) => ({
    ...baseNormalization(item),
    type: coeData.marketTypeTranslated || messageError,
    title: item.offer.productDisplay,
    productCategory:
      item.offer.productCategory || item.offer.category || item.offer.structureType || '--',
    details: [
      ...(item.offer.additionalInfo || []).slice(0, 2).map((info) => ({
        label: info.description,
        value: Utils.Mask.Percentage(info.value),
        type: info.value && info.value > 0 ? 'positive' : 'negative',
      })),
      {
        label: item.offer.suitabilityProductRisk.riskAdjusted ?? messageError,
        value: item.offer.suitabilityProductRisk.scoreAdjusted ?? messageError,
        type: 'risk',
      },
      {
        label: 'Vencimento',
        value: item.offer.maturityDateFormatted ?? messageError,
      },
    ],
    total: {
      label: 'Valor da aplicação',
      value: item.requestedAmountFormatted,
    },
  }));
};
